import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = { class: "p-mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-pb-2" }, [
  /*#__PURE__*/_createTextVNode(" อัพโหลดรูปสินค้า "),
  /*#__PURE__*/_createElementVNode("span", { class: "p-error" }, "*")
], -1)
const _hoisted_4 = { class: "p-mb-3" }
const _hoisted_5 = { class: "p-mb-3" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-py-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Chanel Rouge Allure Velvet Matte Lip Color"),
  /*#__PURE__*/_createElementVNode("div", null, "Chanel Rouge Allure Velvet Matte Lip Color")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadFilePanel = _resolveComponent("UploadFilePanel")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputTextCustom = _resolveComponent("InputTextCustom")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Panel, {
      header: "รายละเอียดการคืนสินค้า",
      toggleable: _ctx.isDisplay,
      collapsed: _ctx.isCollapsed,
      "onUpdate:collapsed": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isCollapsed) = $event))
    }, _createSlots({
      default: _withCtx(() => [
        (!_ctx.isDisplay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", null, [
                  _createVNode(_component_UploadFilePanel, {
                    dataList: _ctx.form.Attachment,
                    modelValue: _ctx.form.Attachment,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Attachment) = $event)),
                    format: "all",
                    name: "fileUpload",
                    text: "ทดสอบ",
                    maxFileLength: 5,
                    onOnFileChange: _ctx.onImageChange,
                    isMultiple: "",
                    typeFile: "image/jpeg, image/png, application/pdf"
                  }, null, 8, ["dataList", "modelValue", "onOnFileChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_InputSelect, {
                  title: "ช่องทางการสั่งซื้อ",
                  text: "ช่องทางการสั่งซื้อ",
                  name: "saleChanelId",
                  valueField: "id",
                  textField: "name",
                  placeholder: "กรุณาเลือก",
                  options: _ctx.returnReason,
                  onOnDataChange: _ctx.onReturnResonChange,
                  "model-value": _ctx.form.returnReasonId,
                  isRequired: "",
                  ref: "saleChanelId"
                }, null, 8, ["options", "onOnDataChange", "model-value"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_InputTextCustom, {
                  "model-value": _ctx.form.returnNote,
                  textFloat: "หมายเลขคำสั่งซื้อ / เลขที่ใบเสร็จ",
                  placeholder: "FAXXXXXXX",
                  type: "text",
                  name: "telephone",
                  maxlength: 10,
                  isRequired: "",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.returnNote = $event)),
                  class: "f-regular"
                }, null, 8, ["model-value"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createVNode(_component_UploadFilePanel, {
                  dataList: _ctx.form.Attachment,
                  modelValue: _ctx.form.Attachment,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Attachment) = $event)),
                  format: "all",
                  name: "fileUpload",
                  text: "ทดสอบ",
                  maxFileLength: 5,
                  onOnFileChange: _ctx.onImageChange,
                  isMultiple: "",
                  typeFile: "image/jpeg, image/png, application/pdf"
                }, null, 8, ["dataList", "modelValue", "onOnFileChange"])
              ]),
              _hoisted_7
            ]))
      ]),
      _: 2
    }, [
      (_ctx.isDisplay)
        ? {
            name: "icons",
            fn: _withCtx(() => [
              (!_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "pi pi-chevron-up",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
                  }))
                : _createCommentVNode("", true),
              (_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: "pi pi-chevron-down",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
                  }))
                : _createCommentVNode("", true)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["toggleable", "collapsed"])
  ]))
}